export default {
  'component.tagSelect.expand': 'Utvide',
  'component.tagSelect.collapse': 'Kollapse',
  'component.tagSelect.all': 'Alle',
};
